// extracted by mini-css-extract-plugin
module.exports = {"menu-bar-block":"src-components-organisms-MenuBarBlock-___style__menu-bar-block___1FZtQ"};